import exifr from 'exifr';

export const removeExifData = async (file) => {
  if (!file.type.startsWith('image/')) {
    return file;
  }

  try {
    const img = new Image();
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const imageUrl = URL.createObjectURL(file);
    
    await new Promise((resolve, reject) => {
      img.onload = resolve;
      img.onerror = reject;
      img.src = imageUrl;
    });

    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage(img, 0, 0);

    URL.revokeObjectURL(imageUrl);

    const blob = await new Promise((resolve) => {
      canvas.toBlob(resolve, file.type);
    });

    return new File([blob], file.name, { type: file.type });
  } catch (error) {
    console.error('Error removing EXIF data:', error);
    return file;
  }
};
